package haxe.ui.parsers.ui;

class JSONParser extends ObjectParser {
    public function new() {
        super();
    }
}